import { get, patch, post } from 'apis';
import PharmacyRoutes from './Pharmacy.Routes';

const PharmacyServices = {
  getPharmacies: async (params) => {
    const data = await get(PharmacyRoutes.getPharmacies, params);
    return data;
  },
}

export default PharmacyServices